import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import responses from './responses';
import { useComposer } from '../../hooks/index';

const ComposerContent = ({ rtl = 'ltr' }) => {
  const { response } = useComposer();

  const Input = useMemo(() => {
    return responses.find(({ id }) => id === response.type).Input;
  }, [response.type]);

  return <Input rtl={rtl} />;
};

ComposerContent.propTypes = {
  rtl: PropTypes.oneOf(['rtl', 'ltr'])
};

export default ComposerContent;
